import { render, staticRenderFns } from "./tag-set.vue?vue&type=template&id=2cde257b&scoped=true"
import script from "./tag-set.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-set.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde257b",
  null
  
)

export default component.exports